<template>
  <div class="g-box">
    <!--ぱんくず-->
    <breadcrumb :pathList="pathList">
    </breadcrumb>
    <!--/ぱんくず-->
    <main class="g-content">
      <h1 class="g-h-1 g-rainbow">このサイトについて</h1>
      <section class="g-unit-xl">
        <p>みんぱくカレイドスコープ「フォーラム型情報ミュージアム標本資料統合データベース」は、フォーラム型情報ミュージアムのプロジェクトが構築し公開している標本資料のデータベースをまとめて検索できる統合検索サイトです。共通索引による横断検索や連想検索のほか、標本資料目録情報など、他の関係データベースの情報をあわせて閲覧することもできます。</p>
      </section>
      <section class="g-unit-xl">
        <p><b>収録データベース（2022年3月現在）</b></p>
        <ul class="g-list g-list-disc">
          <li><a class="g-link" href="https://ifm.minpaku.ac.jp/taiwan/" target="_blank">台湾および周辺島嶼の物質文化<i class="g-i g-i-blank" aria-hidden="true"></i></a></li>
          <li><a class="g-link" href="https://ifm.minpaku.ac.jp/georgebrown/" target="_blank">ジョージ・ブラウン・コレクション<i class="g-i g-i-blank" aria-hidden="true"></i></a></li>
          <li><a class="g-link" href="https://ifm.minpaku.ac.jp/japaneseCulture/" target="_blank">日本の文化展示関連情報データベース<i class="g-i g-i-blank" aria-hidden="true"></i></a></li>
          <li><a class="g-link" href="https://ifm.minpaku.ac.jp/canada/" target="_blank">北米北方先住民関連文化資源データベース<i class="g-i g-i-blank" aria-hidden="true"></i></a></li>
          <li><a class="g-link" href="https://ifm.minpaku.ac.jp/mepc/" target="_blank">中東地域民衆文化資料データベース<i class="g-i g-i-blank" aria-hidden="true"></i></a></li>
        </ul>
      </section>
    </main>
  </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue'

export default {
  components: {
    breadcrumb
  },
  computed: {
    // パン屑リスト
    pathList: function() {
      return [
        { path: '/', text: 'Site.home' },
        { path: '/about', text: 'Site.about_this_website' },
      ]
    },
  }
}

</script>